module.exports = __webpack_public_path__ + "static/media/gurjant.93d6175c.png";